import { useRegionTimezone } from "../../Regions/hooks/useRegionTimezone.js";
import { useLocationContext } from "../../Locations/contexts/LocationContext.js";
import { ServicePeriodInstancesCalendar } from "../calendar/ServicePeriodInstancesCalendar.js";
import "react";
import { jsx } from "react/jsx-runtime";
//#region src/modules/ServicePeriods/location-panel/ServicePeriodHistoryCalendar.tsx
function ServicePeriodHistoryCalendar() {
	const { location, locationId } = useLocationContext(true);
	const timezone = useRegionTimezone(location.regionId);
	return /* @__PURE__ */ jsx("div", {
		className: "mt-xs",
		children: /* @__PURE__ */ jsx(ServicePeriodInstancesCalendar, {
			locationId,
			persistKey: `locsvcperiods_${locationId}_cal`,
			rangeMode: "history",
			timezone
		})
	});
}
//#endregion
export { ServicePeriodHistoryCalendar };

//# sourceMappingURL=ServicePeriodHistoryCalendar.js.map